import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useSearchParams } from 'react-router-dom';
import * as systemDataActions from '../Redux/SystemData/systemDataActions';

const LANG_STORAGE_KEY = 'user_language_selection';

export function saveLanguageSelection(lang) {
    try { localStorage.setItem(LANG_STORAGE_KEY, lang); } catch (_) {}
}

function getSavedSelection() {
    try { return localStorage.getItem(LANG_STORAGE_KEY); } catch (_) { return null; }
}

// Kicks off the single bootstrap load for the public site. We pass the user's
// explicit preference (saved selection → URL param) so the server serves that
// language when it's enabled; the server otherwise resolves the language itself
// (single-language config, or geo refinement handled inside loadBootstrap).
const useLanguageParam = () => {
    const dispatch = useDispatch();
    const [searchParams] = useSearchParams();

    useEffect(() => {
        const saved = getSavedSelection();
        const param = searchParams.get('lan') || searchParams.get('language');
        const preferred = [saved, param].find(l => l === 'he' || l === 'en') || null;

        dispatch(systemDataActions.loadBootstrap(preferred));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [searchParams]);
};

export default useLanguageParam;
